import { useEffect } from 'react';
import jwt from 'jsonwebtoken';
import { pushLog2DV2LogServer } from '../../services/logging';
import { ApiConstant } from '../../v3/constants';

/**
 * This function logs vetsmith usage information. It doesn't contain any functionality related logic
 * It also saves "Dwell time", it is the amount of seconds that the user spent on the page
 * @param {String} url The url of the API to call for saving dwell time
 * @param {String} sessionId The id of user's session
 * @param {Number} vetsmithFlow Vetsmith flow object
 * @param {String} source Source of user's visit (email | whatsapp | portal | vetsmith_subscribe | vetting_engine)
 * @param {Number} templateId Comms Template id from which the user visited
 */
export const useSaveDwellTime = (url, sessionId, vetsmithFlow, source, templateId) => {
  
  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    const token = localStorage.getItem('token');
    const user = jwt.decode(token);
    const logBody = {
      userAgent,
      isMobile,
      sessionId,
      user,
      screenWidth: screen.width,
      screenHeight: screen.height,
      dwellTime: null,
      source: source || 'portal',
      templateId,
      vetsmithFlow
    }
    pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_SESSION_${sessionId}`, {}, logBody);

    const handleBeforeunload = async () => {
      const headers = {
        type: 'application/json',
        Authorization: `${token}`,
      };
      fetch(`${ApiConstant.BASE_URL}${url}/${sessionId}`, {
        method: 'POST',
        body: JSON.stringify({}),
        headers,
        keepalive: true,
      });
    };
    window.addEventListener('beforeunload', handleBeforeunload);
    return () => {
      // Call when component is deactivated
      handleBeforeunload();
      window.removeEventListener('beforeunload', handleBeforeunload);
    };
  }, [url]);
};
